import { Editor, Extension } from "@tiptap/core";
import Suggestion from "@tiptap/suggestion";

const SkillCommands = Extension.create<{ suggestion: any }>({
  name: "skillCommand",
  priority: 200,
  addOptions: () => ({
    suggestion: {
      char: "/",
      startOfLine: true,
      command: ({
        editor,
        range,
        props,
      }: {
        editor: Editor;
        range: any;
        props: any;
      }) => {
        props.command({ editor, range, props });
      },
    },
  }),
  addProseMirrorPlugins() {
    return [
      Suggestion({
        editor: this.editor,
        ...this.options.suggestion,
      }),
    ];
  },
});

export default SkillCommands;
